import { AxiosService } from 'services';
export function DeleteContactService(id) {

  return AxiosService().delete(`/contact/delete?idContact=${id}`)
  .then(function (response) {
    return response;
  }).catch(function (error) {
    console.log(error);
  });
}
